import { ArrayHelpers, DomHelpers, Help, SystemText } from 'e4shared';
import { benchmarkColour } from 'helpers/metrics';
import React from 'react';
import { useSelector } from 'react-redux';
import Details from '../integrationMetrics/components/details';

export const RealtimeMetrics = ({ realtimeMetrics, extraMetrics, integration, profile }) => {
    const user = useSelector(state => state.user.user);
    const [showDetails, setShowDetails] = React.useState(false);

    const resizeHandler = () => {
        setTimeout(DomHelpers.shrinkFont('label-text-fit', 12), 250);
        setTimeout(DomHelpers.shrinkFont('lg-label-text-fit', 30), 250);
    };

    React.useEffect(() => {
        window.addEventListener('resize', resizeHandler);
        resizeHandler();

        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, []);

    React.useEffect(() => {
        ArrayHelpers.existsAndHasLength(realtimeMetrics) && resizeHandler();
    }, [realtimeMetrics]);

    const metrics = extraMetrics.filter(x => x.integration === integration);
    return realtimeMetrics?.length > 0 && metrics?.length > 0 ? (
        <div>
            <div data-testid="crmmetrics-realtime-header" className="watermark-bar">
                <span>{SystemText('User121/CrmMetrics/Realtime/Header')}</span>
                <hr className="mb20" />
            </div>
            <div className="row">
                {metrics.map((e, i) => {
                    const rtm = realtimeMetrics.find(m => m.property?.toLowerCase() === e.property?.toLowerCase());
                    const cols = metrics.length % 2 === 1 && i === metrics.length - 1 ? 12 : 6;

                    return (
                        <div key={`extras-${i}`} className={`col-md-${cols}`}>
                            <div className={`info-box label ${benchmarkColour(e.percentile)}-inverse`}>
                                <div className="mt5">
                                    <span className="lg-label-text-fit">
                                        {e.format === 'M' ? user.currencySymbol : ''}
                                        {e.value.toLocaleString('en', {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0,
                                        })}
                                        {e.format === 'P' ? '%' : ''}
                                    </span>
                                </div>
                                <div>
                                    <span className="label-text-fit">
                                        {rtm?.name}
                                        {rtm?.description && <Help id={`rthelp-${rtm?.id}`}>{rtm?.description}</Help>}
                                        {rtm?.ref === 'e4' && e.value > 0 && (
                                            <button className="btn-link ml5" onClick={() => setShowDetails(rtm)}>
                                                <div className={`text-${benchmarkColour(e.percentile)}`}>
                                                    <i
                                                        title={SystemText('User121/CrmMetrics/Realtime/Details')}
                                                        className="fa fa-binoculars"
                                                    />
                                                </div>
                                            </button>
                                        )}
                                    </span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            <Details
                metric={showDetails}
                profile={profile}
                show={showDetails}
                range=""
                offset=""
                close={() => setShowDetails(null)}
            />
        </div>
    ) : null;
};

export default RealtimeMetrics;
